export { default } from './Tab';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/Tab/index.js
// module id = 358
// module chunks = 0